import { Component, Inject, OnInit } from '@angular/core';
import { Material } from '@classes/material';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MaterialService } from 'app/core/services/material.service';
import { UiService } from 'app/core/services/ui.service';

@Component({
  selector: 'app-material-detail',
  templateUrl: './material-detail.component.html',
  styleUrls: ['./material-detail.component.scss']
})
export class MaterialDetailComponent implements OnInit {

  materialForm: FormGroup;
  isDangerousProduct = false;
  dangerousLevel: number;

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<MaterialDetailComponent>,
    private materialService: MaterialService,
    private uiService: UiService,
    @Inject(MAT_DIALOG_DATA) public data: Material
  ) { }

  ngOnInit() {
    this.initFormBuilder();
  }
  private initFormBuilder() {
    const fb = this.formBuilder;
    const materialForm = this.materialForm = fb.group({
      id: fb.control(this.data?.id),
      name: fb.control(this.data?.name, [Validators.required, Validators.maxLength(50)]),
      // dangerousLevel: fb.control(this.data?.dangerousLevel, []),
    });
    this.isDangerousProduct = (this.data?.dangerousLevel || 0) > 0;
    this.dangerousLevel = this.isDangerousProduct ? (this.data?.dangerousLevel || 0) : 0;
    // this.isDangerousProduct = true;
  }

  onSubmit() {
    const material = new Material(
      this.materialForm.value
    )
    material.dangerousLevel = (this.isDangerousProduct && this.dangerousLevel > 0) ? (this.dangerousLevel || 0) : null;
    this.uiService.addRouteLoading();
    this.materialService.createOrUpdateMaterial(material).subscribe(data => {
      this.dialogRef.close({
        success: true,
        data
      });
      this.uiService.displayMessageToast('material.success-edit');
      this.uiService.removeRouteLoading();
    }, error => {
      console.error(error);
      this.uiService.removeRouteLoading();
    })
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
